/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Přepravní štítek vygenerován`
};

const da_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Forsendelseslabel genereret`
};

const de_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Versandlabel erstellt`
};

const en_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Label generated`
};

const es_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Etiqueta de envío generada`
};

const fr_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Bon d'expédition généré`
};

const hu_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítási címke generálva`
};

const it_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Etichetta di spedizione generata`
};

const nl_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Verzendlabel aangemaakt`
};

const pl_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Wygenerowano etykietę wysyłkową`
};

const pt_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Etiqueta de envio gerada`
};

const sv_order_statuses_complete_label_generated = /** @type {(inputs: {}) => string} */ () => {
	return `Fraktsedel skapad`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_statuses_complete_label_generated = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_statuses_complete_label_generated(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_statuses_complete_label_generated", locale)
	if (locale === "cs") return cs_order_statuses_complete_label_generated(inputs)
	if (locale === "da") return da_order_statuses_complete_label_generated(inputs)
	if (locale === "de") return de_order_statuses_complete_label_generated(inputs)
	if (locale === "en") return en_order_statuses_complete_label_generated(inputs)
	if (locale === "es") return es_order_statuses_complete_label_generated(inputs)
	if (locale === "fr") return fr_order_statuses_complete_label_generated(inputs)
	if (locale === "hu") return hu_order_statuses_complete_label_generated(inputs)
	if (locale === "it") return it_order_statuses_complete_label_generated(inputs)
	if (locale === "nl") return nl_order_statuses_complete_label_generated(inputs)
	if (locale === "pl") return pl_order_statuses_complete_label_generated(inputs)
	if (locale === "pt") return pt_order_statuses_complete_label_generated(inputs)
	return sv_order_statuses_complete_label_generated(inputs)
};
export { order_statuses_complete_label_generated as "order_statuses.complete_label_generated" }